import { render } from "./SupportModal.vue?vue&type=template&id=01f0252e&scoped=true&ts=true"
import script from "./SupportModal.vue?vue&type=script&lang=ts"
export * from "./SupportModal.vue?vue&type=script&lang=ts"

import "./SupportModal.vue?vue&type=style&index=0&id=01f0252e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f0252e"]])

export default __exports__